<template>
  <!--下单成功-->
  <div class="success-box">
    <img src="../../assets/success.png"/>

    <div class="order">恭喜您！订单提交成功！</div>
    <div class="send">预计{{ data }}安排配送</div>
    <div class="number">订单号：{{ orderNumber }}</div>
    <div class="send">支付方式：</div>
    <div class="send">与益力多姐姐现金交易</div>

    <div class="success-btn">
      <div class="left" @click="handleLook(orderId)">查看详情</div>
      <div class="right" @click="handleOrder">继续下单</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PackageOrderSuccess",

  data() {
    return {
      orderId: this.$route.query.orderId,
      orderNumber: this.$route.query.orderNumber,
      data: this.$route.query.orderData
    }
  },

  methods: {
    handleLook(orderId) {
      let status = '未配送';
      this.$router.push({path: '/packagePeriodOrderDetail', query:{orderId, status}})
    },

    handleOrder() {
      this.$router.go(-1);
    }
  }
}
</script>

<style lang="scss" scoped>

.success-box {
  color: #ea2d53;
  position: absolute;
  height: 96%;
  font-size: 0.7rem;
  border: 2px solid #ea2d53;
  border-radius: 10px;
  margin: 10px;
  background: white;

  img {
    width: 100%;
  }

  .order {
    font-size: 1.3rem;
    margin-top: 40px;
  }

  .number {
    margin-top: 20px;
    font-size: 1rem;
    margin-bottom: 10px;
  }

  .send {
    margin-top: 20px;
    font-weight: bold;
    font-size: 1.3rem;
  }

  .success-btn {
    margin-top: 30px;
    color: #ea2d53;
    font-size: 1rem;
    div{
      border-radius: 5px;
      border: 1px solid #ea2d53;
      padding: 8px 25px;
    }
    .left {
      float: left;
      margin-left: 30px;
    }

    .right {
      float: right;
      margin-right: 30px;
    }
  }

}

</style>